/**
 * Returns a DateRange for the entire current day, in local time.
 */
export const getToday = (now = new Date()): DateRange => {
    const start = new Date(now);
    const end = new Date(now);

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    return { start, end };
};
